import { useCallback } from 'react';
import { formatZeit } from '@schnitt/shared';
import { useEditor } from './store';

/**
 * Eine Zeit so schreiben, wie dieses Gerät sie lesen will (S31).
 *
 * Alle Stellen, die eine Zeit anzeigen, gehen hier durch -- sonst stünde nach
 * dem Umschalten die halbe App im alten Format. Der Takt kommt aus den
 * Projekteinstellungen und nicht aus einer Vorgabe: bei 25 Bildern ist die
 * Bildnummer eine andere als bei 30, und eine Bildnummer, die zum Projekt
 * nicht passt, ist schlimmer als keine.
 *
 * `genau` sagt, ob die Stelle das letzte Bild nennen soll. An der Skala der
 * Zeitleiste nicht, am Anfasser eines Clips ja.
 */
export function useZeitText(): (sec: number, genau?: boolean) => string {
  const format = useEditor((s) => s.zeitformat);
  const fps = useEditor((s) => s.timeline.settings.fps);
  return useCallback((sec: number, genau = false) => formatZeit(sec, fps, format, genau), [format, fps]);
}

/**
 * Dasselbe für eine Stelle, die keinen Haken aufrufen kann -- in einem
 * Rückruf, einem Meldungstext, einem `title`. Sie liest den Stand direkt und
 * zeichnet deshalb nicht neu; für einen Text, der im selben Augenblick
 * entsteht, ist das richtig.
 */
export function zeitText(sec: number, genau = false): string {
  const s = useEditor.getState();
  return formatZeit(sec, s.timeline.settings.fps, s.zeitformat, genau);
}
